import Progress from 'root/components/Progress/Progress';
import consts from '../../data/consts';
import Plans from './Plans';
import Sizes from './Sizes';
import Info from './Info';
import Meta from './Meta';

const CLASSES = {
  borderTop: 'bw1 bb-0 bl-0 br-0 b--solid bc-window-border',
  padding: 'p-4',
  infoLine: 'flex items-center pt3 pb3',
  resetList: 'pl0 m-0 list',
  label: 'b mb-4 db',
};

const getPurchaseVariantInfo = (purchaseDetails, asset) => {
  let variant = null;

  if (purchaseDetails.size) {
    variant = asset.assets[purchaseDetails.size];

    if (!variant) {
      const sizeType = Object.keys(consts.SIZE_TYPES).find(
        (size) => consts.SIZE_TYPES[size].name && consts.SIZE_TYPES[size].name === purchaseDetails.size
      );

      if (sizeType) {
        variant = asset.assets[sizeType];
      }
    }
  }

  return variant;
};

const PurchaseSidePanel = (props) => {
  const selectedVariant = props.asset && getPurchaseVariantInfo(props.purchaseDetails, props.asset);
  const hasRelevantPlan = !!props.purchaseDetails.plan;

  return props.asset ? (
    <ul className={`side-panel flex flex-column bg-window relative flex-shrink-0 w-100 w-45-ns h-100-ns overflow-y-auto-ns ${CLASSES.resetList}`}>
      <Plans
        className={CLASSES.padding}
        plan={props.purchaseDetails.plan}
        subscriptions={props.subscriptions}
        mediaType={props.mediaType}
        changePurchaseDetails={props.changePurchaseDetails}
      />

      {hasRelevantPlan && (
        <Sizes
          className={`${CLASSES.borderTop} ${CLASSES.padding}`}
          size={props.purchaseDetails.size}
          asset={props.asset}
          currentSubscription={props.currentSubscription}
          purchaseDetails={props.purchaseDetails}
          sizeParams={props.sizeParams}
          format={props.format}
          selectedVariant={selectedVariant}
          mediaType={props.mediaType}
          changePurchaseDetails={props.changePurchaseDetails}
        />
      )}

      <Info
        className={`${CLASSES.borderTop} ${CLASSES.padding}`}
        asset={props.asset}
        selectedVariant={selectedVariant}
        format={props.format}
        withDescription={!hasRelevantPlan}
      />

      {hasRelevantPlan && props.metadataSchema.length ? (
        <Meta
          className={`${CLASSES.borderTop} ${CLASSES.padding}`}
          asset={props.asset}
          currentSubscription={props.currentSubscription}
          metadataSchema={props.metadataSchema}
          purchaseDetailsMeta={props.purchaseDetails.metadata}
          changePurchaseDetails={props.changePurchaseDetails}
        />
      ) : null}
    </ul>
  ) : (
    <div className="flex w-100 w-45-ns h-100-ns flex-grow-1 relative side-panel bg-window">
      <Progress size={42} overlay />
    </div>
  );
};

export default PurchaseSidePanel;
